import React from "react";
import { Accordion } from "react-bootstrap";

import WPHeading from "../WPHeading";

import "./WPAccordionGroup.scss";

const WPAccordionGroup = ({ data }) => (
  <div className='wavepro-accordian-container'>
    <Accordion>
      {data.map((accordionData, index) => (
        <Accordion.Item eventKey={index.toString()} key={index}>
          <Accordion.Header>
            <WPHeading className='accordion-header' type='default'>
              {accordionData.title}
            </WPHeading>
          </Accordion.Header>
          <Accordion.Body>
            <WPHeading
              secondary
              type='default'
              size='small'
              text={accordionData.description}
              renderHtml
              wrapContent={false}
              className='accordion-description'
            />
            {accordionData?.items && (
              <ul>
                {accordionData.items.map((item, itemIndex) => (
                  <li key={itemIndex}>{item}</li>
                ))}
              </ul>
            )}
          </Accordion.Body>
        </Accordion.Item>
      ))}
    </Accordion>
  </div>
);

export default WPAccordionGroup;
